<div class="selectorini-wrapper" [class.disabled]="disabled" [class.dropup]="dropUp">
  <!-- Control -->
  <div class="selectorini-control d-flex align-items-center justify-content-between"
       (click)="toggleDropdown()">
    <!-- Multiple pills -->
    <div *ngIf="multiple" class="d-flex flex-wrap gap-2 w-100">
      <span *ngIf="!valueArray.length" class="text-muted">{{ placeholder }}</span>
      <span *ngFor="let item of valueArray" class="badge rounded-pill px-2 py-1"
            (click)="$event.stopPropagation()">
        {{ getLabel(item) }}
        <i class="fa fa-times ms-1" (click)="removeItem(item); $event.stopPropagation()"></i>
      </span>
    </div>

    <!-- Single text -->
    <div *ngIf="!multiple" class="text-truncate w-100" (click)="$event.stopPropagation()">
      <span *ngIf="!hasSelection" class="text-muted">{{ placeholder }}</span>
      <span *ngIf="hasSelection">{{ getLabel(value) }}</span>
    </div>

    <i class="fa fa-chevron-down ms-2"></i>
  </div>

  <!-- Menu -->
  <ul #menuEl class="dropdown-menu selectorini-menu show w-100" *ngIf="isOpen">
    <li *ngFor="let opt of filteredOptions"
        class="dropdown-item d-flex justify-content-between align-items-center"
        [class.active]="isSelected(opt)"
        (click)="selectItem(opt); $event.stopPropagation()">
      <span>{{ getLabel(opt) }}</span>
      <i *ngIf="isSelected(opt)" class="fa fa-check"></i>
    </li>
  </ul>
</div>
